/* eslint-disable no-unused-vars */
import PText from "../../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Button, IconButton, Tooltip } from "@mui/material";
import Divider from "@mui/material/Divider";
import MUIDataTable from "mui-datatables";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import db from "../../../db/db";

export default function ProductBarcodeView(props) {
  const { t } = useTranslation();
  const translate = t;

  useEffect(() => {
    if (props.tableMeta) {
      if (props.barcodeData.length == 0) {
        showProductBarcodeView(props.tableMeta);
      }
    }
  }, []);

  function showProductBarcodeView(tableMeta) {
    let barcodeDataTemp = [];
    let tempBarcodeList = tableMeta.tableData[tableMeta.rowIndex][6].v;
    for (let i = 0; i < tempBarcodeList.length; i++) {
      if (tempBarcodeList[i] && tempBarcodeList[i] != "") {
        barcodeDataTemp.push({
          serialNumber: barcodeDataTemp.length + 1,
          barcode: tempBarcodeList[i],
        });
      }
    }
    props.setBarcodeData(barcodeDataTemp);
  }

  function generateAutoBarcode(tableMeta) {
    if (
      props.deptId != null &&
      props.deptId != undefined &&
      props.deptId != ""
    ) {
      setAutoBarcodeFromDeptId(props.deptId, tableMeta);
    } else {
      props.showMessage(
        "error",
        translate(
          "Department is empty, Please select any department for generate barcode"
        )
      );
    }
  }

  async function setAutoBarcodeFromDeptId(deptObj, tableMeta) {
    console.log("generating Barcode");
    let dbData = await db.product.where("deptId").equals(deptObj.id).toArray();

    //DOuble Check the Logic
    let loop = 0;
    let newCode = "";
    while (loop >= 0) {
      newCode = zeroFill(
        deptObj.code +
          (tableMeta.rowIndex + 1).toString() +
          (dbData.length + 11111 + loop).toString(),
        12
      );
      let prodData = await db.product
        .where("barcodeList")
        .equals(newCode)
        .toArray();

      if (prodData.length == 0) {
        break;
      } else {
        loop++;
      }
    }

    let barcodeDataTemp = [...props.barcodeData];
    barcodeDataTemp[0].barcode = newCode;
    props.setBarcodeData(barcodeDataTemp);
  }

  function zeroFill(code, width) {
    width -= code.length;
    if (width > 0) {
      return code + new Array(width + (/\./.test(code) ? 2 : 1)).join("0");
    }
    return code + ""; // always return a string
  }

  const options = {
    filterType: null,
    search: false,
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    pagination: false,
    selectableRows: "false",
    selectableRowsHeader: true,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: 300,
  };

  const columns = [
    {
      name: "serialNumber",
      label: translate("SN"),
      options: {
        filter: false,
        sort: false,
        display: "true",
      },
    },
    {
      name: "barcode",
      label: translate("Barcode"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 350 }}>
            <table width="100%">
              <tbody>
                <tr>
                  <td width="95%">
                    <PText
                      value={value}
                      type="text"
                      onChange={(e) => {
                        let tempData = [...tableMeta.tableData];
                        tempData[tableMeta.rowIndex].barcode = e.target.value;
                        props.setBarcodeData(tempData);
                      }}
                    ></PText>
                  </td>
                  {tableMeta.rowIndex == 0 && value === "" && (
                    <td width="5%">
                      <Tooltip title={"Generate auto barcode"}>
                        <IconButton
                          aria-label="close"
                          onClick={() => {
                            generateAutoBarcode(tableMeta);
                          }}
                        >
                          <AddIcon />
                        </IconButton>
                      </Tooltip>
                    </td>
                  )}
                </tr>
              </tbody>
            </table>
          </div>
        ),
      },
    },
    {
      name: "action",
      label: translate("Action"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customHeadLabelRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              <table width="100%">
                <tr>
                  <td>{translate("Action")}</td>
                  <td>
                    <Tooltip title={"Add new row"}>
                      <IconButton
                        color="secondary"
                        onClick={() => handleAddRow()}
                      >
                        <AddIcon />
                      </IconButton>
                    </Tooltip>
                  </td>
                </tr>
              </table>
            </div>
          );
        },
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <Button
              onClick={() => onRemoveItemClicked(tableMeta, updateValue, value)}
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "right",
              }}
            >
              {translate("REMOVE")}
            </Button>
          </div>
        ),
      },
    },
  ];

  function onRemoveItemClicked(tableMeta, updateValue, value) {
    let barcodeDataTemp = [...props.barcodeData];
    let updatedList = [];
    let index = 0;
    for (let i = 0; i < barcodeDataTemp.length; i++) {
      if (tableMeta.rowIndex != i) {
        barcodeDataTemp[i].serialNumber = index + 1;
        updatedList.push(barcodeDataTemp[i]);
        index++;
      }
    }
    props.setBarcodeData(updatedList);
  }

  function handleAddRow() {
    let barcodeDataTemp = [...props.barcodeData];
    barcodeDataTemp.push({
      serialNumber: barcodeDataTemp.length + 1,
      barcode: "",
    });
    props.setBarcodeData(barcodeDataTemp);
  }

  async function onSave() {
    let barcodes = [];
    props.barcodeData.map((item) => {
      if (item.barcode && item.barcode != "") {
        barcodes.push(item.barcode);
      }
    });
    let tempPricingData = [...props.tableMeta.tableData];
    tempPricingData[props.tableMeta.rowIndex][6].v = barcodes;
    props.setPricingData(tempPricingData);
    props.showMessage("success", translate("Saved sucessfully"));
  }

  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <Divider style={{ marginBottom: "5px" }} />
          <MUIDataTable
            data={props.barcodeData}
            columns={columns}
            options={options}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            width: "95%",
            position: "absolute",
            bottom: 20,
          }}
        >
          <Divider />
          <table width="100%">
            <tbody>
              <tr>
                <td width="95%"></td>
                <td>
                  <Button
                    style={{ marginTop: "5px" }}
                    onClick={onSave}
                    variant="contained"
                    color="primary"
                  >
                    Save
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
      </Grid>
    </div>
  );
}
